export interface AppLogoProps {
  /** 베타 배지 표시 여부 @default true */
  showBeta?: boolean;
}

/**
 * AppLogo - AX Studio 로고 컴포넌트
 *
 * Header, Footer 등 여러 위젯에서 재사용되는 공유 컴포넌트.
 * FSD 규칙상 widgets 간 import가 불가하므로 shared에 배치.
 */
export function AppLogo({ showBeta = true }: AppLogoProps) {
  return (
    <div className="flex gap-2 h-6 flex-nowrap">
      <img src="/images/logo/ax-logo.png" width={110} height={24} alt="AX Logo" />
      {showBeta && <img src="/images/logo/beta.png" width={55} height={24} alt="Beta" />}
    </div>
  );
}
